<template>
  <div class="container">
    <div class="info" v-if="info.id">
      <el-descriptions title="投资包信息">
        <el-descriptions-item label="投资包">{{
          info.package_name
        }}</el-descriptions-item>
        <el-descriptions-item label="编号">{{
          info.union_no
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag type="info" size="small" v-if="info.status === 0"
            >众筹中</el-tag
          >
          <el-tag type="success" size="small" v-if="info.status === 1"
            >众筹成功</el-tag
          >
          <el-tag type="danger" size="small" v-if="info.status === 2"
            >失败</el-tag
          >
          <!-- <el-button @click="pass(1)" type="success" v-if="info.status == 0"
            >众筹成功</el-button
          > -->
          <!-- <el-button @click="pass(2)" type="danger" v-if="info.status == 0"
            >失败</el-button
          > -->
        </el-descriptions-item>
        <el-descriptions-item label="总金额">{{
          info.total_value || 0
        }}元</el-descriptions-item>
          <el-descriptions-item label="份额">总{{
          info.total_shares || ""
        }}，最低认领{{info.min_investment_shares}}份</el-descriptions-item>
          <el-descriptions-item label="持续时间">{{
          info.start_time || ""
        }}到{{info.end_time}}</el-descriptions-item>
      
      </el-descriptions>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="份额认领" name="pInvest">
        <packageInvest ref="pInvest"></packageInvest>
      </el-tab-pane>
      <el-tab-pane label="投资门店" name="bindMec">
        <bindMec ref="bindMec"></bindMec>
      </el-tab-pane>
     
    </el-tabs>
  </div>
</template>

<script>
import packageInvest from "../components/packageInvest/list.vue";
import bindMec from "../components/bindMec/list.vue";
export default {
  components: {
  packageInvest,
  bindMec
  },
  data() {
    return {
      id: "",
      info: {},
      audit: {},
      activeName: "pInvest",
      manager: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetails();
    this.$nextTick(() => {
      this.$refs[this.activeName].init();
    });
  },

  methods: {
      pass(s) {
      let url = "/user/investPackageUnion/update";
      this.$axios
        .post(url, {
          id: this.id,
          status: s,
        })
        .then((res) => {
         this.info.status = s;
        });
    },
    handleClick(tab) {
      this.$refs[tab.name].init();
    },
    getDetails() {
      this.$axios({
        url: "/user/investPackageUnion/findById",
        params: {
          id: this.id,
        },
      }).then((res) => {
        this.info = res.data.data
      });
    },
  },
};
</script>

<style lang="less" scoped>
.info {
  margin-bottom: 30px;
}
.desc{
  white-space: pre-wrap;
}
</style>